<template>
  <div v-if="!item.hidden">
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      "
    >
      <app-link
        v-if="onlyOneChild.meta"
        :to="resolvePath(onlyOneChild.path, onlyOneChild.query)"
      >
        <el-menu-item
          :index="resolvePath(onlyOneChild.path)"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <el-icon v-if="isElementPlusIcon(onlyOneChild.meta.icon || (item.meta && item.meta.icon))">
            <component :is="onlyOneChild.meta.icon || (item.meta && item.meta.icon)" />
          </el-icon>
          <svg-icon v-else
            :icon-class="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
          />
          <template #title
            ><span
              @click="handleRoutesFather(item)"
              class="menu-title"
              :title="hasTitle(onlyOneChild.meta.title)"
              >{{ onlyOneChild.meta.title }}</span
            ></template
          >
        </el-menu-item>
      </app-link>
    </template>

    <el-sub-menu v-else ref="subMenu" :index="resolvePath(item.path)" teleported>
      <template v-if="item.meta" #title>
        <el-icon v-if="isElementPlusIcon(item.meta && item.meta.icon)">
          <component :is="item.meta && item.meta.icon" />
        </el-icon>
        <svg-icon v-else :icon-class="item.meta && item.meta.icon" />
        <span class="menu-title" :title="hasTitle(item.meta.title)">{{
          item.meta.title
        }}</span>
      </template>

      <sidebar-item
        v-for="(child, index) in item.children"
        :key="child.path + index"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        @click="handleRoutes(item)"
        class="nest-menu"
      />
    </el-sub-menu>
  </div>
</template>

<script setup>
import { isExternal } from "@/modules/huyu-framework/backend/utils/validate";
import AppLink from "./Link";
import { getNormalPath } from "@/modules/huyu-framework/backend/utils/ruoyi";
import * as ElementPlusIcons from '@element-plus/icons-vue';

function isElementPlusIcon(name) {
  return name && ElementPlusIcons[name];
}

const props = defineProps({
  // route object
  item: {
    type: Object,
    required: true,
  },
  isNest: {
    type: Boolean,
    default: false,
  },
  basePath: {
    type: String,
    default: "",
  },
});

const onlyOneChild = ref({});

let modelList = JSON.parse(localStorage.getItem("moduleList"));

function handleRoutesFather(item) {

  console.log('组件地址', item.adrees || item.component || 'N/A');
  
  // let moduleId = modelList[0].moduleId;
  let moduleId = item.moduleId;

  // if(moduleId == undefined) {

  //   let title = item.meta.title

  //   let data = modelList.find(item => item.moduleName == title)

  //   if(data == undefined) return

  //   moduleId = data.moduleId

  // }

  localStorage.setItem("moduleId", moduleId);
}
function handleRoutes(item) {

  let data = modelList.find((e) => e.moduleName == item.meta.title);

  if (data == undefined) return;

  localStorage.setItem("moduleId", data.moduleId);
}
function hasOneShowingChild(children = [], parent) {
  if (!children) {
    children = [];
  }
  const showingChildren = children.filter((item) => {
    if (item.hidden) {
      return false;
    } else {
      // Temp set(will be used if only has one showing child)
      onlyOneChild.value = item;
      return true;
    }
  });

  // When there is only one child router, the child router is displayed by default
  if (showingChildren.length === 1) {
    return true;
  }

  // Show parent if there are no child router to display
  if (showingChildren.length === 0) {
    onlyOneChild.value = { ...parent, path: "", noShowingChildren: true };
    return true;
  }

  return false;
}

function resolvePath(routePath, routeQuery) {
  if (isExternal(routePath)) {
    return routePath;
  }
  if (isExternal(props.basePath)) {
    return props.basePath;
  }
  if (routeQuery) {
    let query = JSON.parse(routeQuery);
    return { path: getNormalPath(props.basePath + "/" + routePath), query: query };
  }
  return getNormalPath(props.basePath + "/" + routePath);
}

function hasTitle(title) {
  if (title.length > 5) {
    return title;
  } else {
    return "";
  }
}
</script>
